import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M12.75 21.75a.75.75 0 1 1-1.5 0V15.5c0-2.74-1.122-4.564-2.79-6.292-.723-.75-1.535-1.465-2.406-2.234l-.458-.405a51 51 0 0 1-1.839-1.695v2.369a.75.75 0 0 1-1.5 0V3.105a.75.75 0 0 1 .747-.855H7.25a.75.75 0 1 1 0 1.5H4.753a49 49 0 0 0 1.838 1.697l.448.395c.869.767 1.732 1.528 2.5 2.325 1.833 1.897 3.211 4.074 3.211 7.333zM12.5 10.5a1 1 0 1 0 2 0 1 1 0 0 0-2 0M15.75 9.25a1 1 0 1 1 0-2 1 1 0 0 1 0 2M18 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2" />
    <path d="M21.06 2.25a.75.75 0 0 1 .75.75v4.243a.75.75 0 1 1-1.5 0V3.75h-3.492a.75.75 0 0 1 0-1.5z" />
  </>
);

const OffTrail = Icon('off-trail', svgContents);

export default OffTrail;
